export default __webpack_public_path__ + "static/media/micimg6.7fdb083f.webp";